import type { DirectiveBinding } from 'vue';

interface ClickOutsideElement extends HTMLElement {
  clickOutsideEvent?: (event: Event) => void;
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('click-outside', {
    mounted(el: ClickOutsideElement, binding: DirectiveBinding) {
      el.clickOutsideEvent = function (event: Event) {
        event.stopPropagation();
        const target = event.target instanceof Node ? event.target : null;
        if (!el.contains(target)) {
          binding.value();
        }
      };
      document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unmounted(el: ClickOutsideElement) {
      if (el.clickOutsideEvent) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      }
    },
  });
});
